<!--  Start navbar  -->
<nav class="navbar navbar-expand-lg navbar-dark tc-navbar-st4 {{isNavbarClicked ? 'navbarClicked' : ''}}">
  <div class="container">
      <a class="navbar-brand" title="{{(data | async)?.restaurant_data?.restaurant_name}}" routerLink="/" routerLinkActive="active" (click)="closeNavbar()">
          <img class="logo" [defaultImage]="'./assets/images/placeholder.jpg'" 
          [lazyLoad]="(data | async)?.restaurant_data?.logo" 
          alt="{{(data | async)?.restaurant_data?.logo_alt_text ? (data | async)?.restaurant_data?.logo_alt_text : (data | async)?.restaurant_data?.restaurant_name}}" />
      </a>
      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation" (click)="navBarClicked()">
          <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse justify-content-end" id="navbarSupportedContent">
          <ul class="navbar-nav mx-auto sub-font">
              <li class="nav-item" (click)="closeNavbar()" *ngIf="(data | async)?.restaurant_content?.about_page?.is_active">
                  <a class="nav-link" title="About" [routerLink]="['/about-us']" routerLinkActive="active">About</a>
              </li>
              <li class="nav-item" (click)="closeNavbar()" *ngIf="(data | async)?.restaurant_data?.gift_voucher && (data | async)?.restaurant_content?.gift_voucher_page?.is_active">
                  <a class="nav-link" title="Gift voucher" [routerLink]="['/gift-voucher']" routerLinkActive="active">Gift Voucher</a>
              </li>
              <li class="nav-item" (click)="closeNavbar()" *ngIf="(data | async)?.restaurant_content?.team_page?.is_active">
                <a class="nav-link" title="Team" [routerLink]="['/our-team']" routerLinkActive="active">Team</a>
              </li>
              <li class="nav-item" (click)="closeNavbar()" *ngIf="(data | async)?.restaurant_content?.deals_page?.is_active">
                  <a class="nav-link" title="Deals" [routerLink]="['/deals']" routerLinkActive="active">Deals</a>
              </li>
              <li class="nav-item" (click)="closeNavbar()" *ngIf="(data | async)?.restaurant_content?.xmas_page?.is_active">
                  <a class="nav-link" title="Christmas - {{(data | async)?.restaurant_data?.restaurant_name}}" [routerLink]="['/christmas']" routerLinkActive="active">Christmas</a>
              </li>
              <li class="nav-item" (click)="closeNavbar()" *ngIf="(data | async)?.restaurant_content?.menu_page?.is_active">
                  <a class="nav-link" title="Menu" [routerLink]="['/menu']" routerLinkActive="active">Menu</a>
              </li>
              <li class="nav-item" (click)="closeNavbar()" *ngIf="(data | async)?.restaurant_content?.booking_page?.is_active">
                  <a class="nav-link" title="Reservation" [routerLink]="['/reservation']" routerLinkActive="active">Reservation</a>
              </li>
              <li class="nav-item" (click)="closeNavbar()" *ngIf="(data | async)?.restaurant_content?.review_page?.is_active">
                <a class="nav-link" title="Reviews" [routerLink]="['/reviews']" routerLinkActive="active">Reviews</a>
              </li>
              <li class="nav-item" (click)="closeNavbar()" *ngIf="(data | async)?.restaurant_content?.gallery_page?.is_active">
                  <a class="nav-link" title="Gallery" [routerLink]="['/gallery']" routerLinkActive="active">Gallery</a>
              </li>
              <li class="nav-item" (click)="closeNavbar()" *ngIf="(data | async)?.restaurant_content?.awards_page?.is_active">
                <a class="nav-link" title="Awards" [routerLink]="['/awards']" routerLinkActive="active">Awards</a>
              </li>
              <li class="nav-item" (click)="closeNavbar()" *ngIf="(data | async)?.restaurant_content?.event_page?.is_active">
                <a class="nav-link" title="Events" [routerLink]="['/events']" routerLinkActive="active">Events</a>
              </li>
              <li class="nav-item" (click)="closeNavbar()" *ngIf="(data | async)?.restaurant_content?.blog_page?.is_active">
                <a class="nav-link" title="Blogs" [routerLink]="['/blogs']" routerLinkActive="active">Blog</a>
              </li>
               <li class="nav-item" *ngIf="(data | async)?.restaurant_content?.news_media_page?.is_active">
                <a class="nav-link" title="News & Media - {{(data | async)?.restaurant_data?.restaurant_name}}" [routerLink]="['/news-media']" routerLinkActive="active">News & Media</a>
              </li>
              <li class="nav-item" (click)="closeNavbar()" *ngIf="(data | async)?.restaurant_content?.contact_page?.is_active">
                  <a class="nav-link" title="Contact" [routerLink]="['/contact-us']" routerLinkActive="active">Contact</a>
              </li>

              <li class="nav-item"  (click)="closeNavbar()" *ngIf="(user | async)?.isLogged === false">
                <a class="nav-link" title="Sign In" [routerLink]="['/sign-in']" routerLinkActive="active">Sign In</a>
              </li>

              <li class="nav-item" (click)="signOut(); closeNavbar()" *ngIf="(user | async)?.isLogged === true">
                <a class="nav-link" title="Sign Out">Sign Out</a>
              </li>
              <li class="nav-item" (click)="closeNavbar()" *ngIf="(user | async)?.isLogged === true">
                <a class="nav-link" title="My Account" [routerLink]="['/my-account']" routerLinkActive="active">My Account</a>
              </li>
          </ul>
          <ng-container>
            <div class="social-side justify-content-lg-end" *ngIf="(data | async)?.restaurant_content?.order_online_page?.is_active">
              <div class="phone-link" (click)="closeNavbar()">
                  <h6 class="fsz-24"><a [title]="'Order food online from ' + (data | async)?.restaurant_data?.restaurant_name" [routerLink]="['/order-online']" routerLinkActive="active">Order Online</a> </h6>
                  <img src="assets/img/phone_line.png" alt="Order online" class="bg">
              </div>
            </div>
          </ng-container>
      </div>
  </div>
</nav>

